/**
 * Workspace service, provides functions for available and the current workspace.
 */
angular.module('impactx').service('$workspace', WorkspaceService);
WorkspaceService.$inject = [
    '$context',
    '$location',
    'cookieService',
    'dataGen',
    '$rootScope',
    '$workspaceIdHolder',
    'AppConfiguration',
    'sidebarShow'
];

var ixAngularOnlyMenuItems = [
    'catalogeditor'
];

function WorkspaceService($context, $location, cookieService, dataGen, $rootScope, $workspaceIdHolder, AppConfiguration, sidebarShow) {
    var CONST_WORKSPACE_NAME = "workspaceName";
    var self = this;
    this.logoUrl = '';
    $workspaceIdHolder.currentWorkspaceId = {};
    self.availableWorkspaces = {};
    self.availableWorkspaces.workspaces = [];
    self.currentWorkspace = {};
    self._listenerFunctions = [];
    self.highContrastActive = false;
    self.highContrastKey = 'highContrast';

    this.removeWorkspaceCookie = function () {
        cookieService.removeCookie(CONST_WORKSPACE_NAME + $context.userId.value);
        this.logoUrl = '';
        $workspaceIdHolder.currentWorkspaceId.value = '';
        self.availableWorkspaces = {};
    };

    function getCurrentWorkspace() {
        if (impactX.isDefined(self, 'availableWorkspaces.workspaces')) {
            if (!$workspaceIdHolder.currentWorkspaceId.value && cookieService.getCookieValue(CONST_WORKSPACE_NAME + $context.userId.value)) {
                $workspaceIdHolder.currentWorkspaceId.value = cookieService.getCookieValue(CONST_WORKSPACE_NAME + $context.userId.value);
            }
            var availableWorkspaces = self.availableWorkspaces.workspaces;
            for (var i = 0; i < availableWorkspaces.length; i++) {
                if (availableWorkspaces[i].key === $workspaceIdHolder.currentWorkspaceId.value && availableWorkspaces[i].view) {
                    return self.currentWorkspace;
                }
            }
        }
        return {};
    }

    function getCurrentWorkspaceView() {
        return getCurrentWorkspace().view;
    }

    self.activateWorkspace = function (workspace, redirectToDefault) {
        if (redirectToDefault) {
            var workspaces = self.availableWorkspaces.workspaces;
            for (var i = 0; i < workspaces.length; i++) {
                if (workspaces[i].key === workspace && workspaces[i].view) {
                    $location.url("/" + workspaces[i].view);
                }
            }
        }
        if (workspace) {
            $workspaceIdHolder.currentWorkspaceId.value = workspace;
        }
        if ($context.userId.value) {
            cookieService.removeCookie(CONST_WORKSPACE_NAME + $context.userId.value);
            cookieService.setCookie(CONST_WORKSPACE_NAME + $context.userId.value, $workspaceIdHolder.currentWorkspaceId.value, 300, false);
        }
        self.refreshMenuItems(self.getCurrentWorkspaceId().value);
        //TODO: An Angular melden.
    };

    function refreshAvailableWorkspaces($scope, dataGen, $context, $workspace) {
        return dataGen.getData($scope, {}, "/workspace/available").then(function () {
            var data = $scope.data;
            if (data !== null && data !== undefined) {
                if (data) {
                    if ((!currentWorkspaceAllowed($workspace, data)) && data.workspaces && data.workspaces[0]) {
                        $workspaceIdHolder.currentWorkspaceId.value = data.workspaces[0].key;
                    }
                    self.availableWorkspaces = data;
                    if ($workspaceIdHolder.currentWorkspaceId.value) {
                        self.refreshMenuItems(self.getCurrentWorkspaceId().value);
                        if ($context.needsDataInput())
                        {
                            sidebarShow.close();
                            sidebarShow.setToggleIsHidden(true);
                        }
                        else if (data.showSmallMenu) {
                            sidebarShow.close();
                            sidebarShow.setToggleIsHidden(false);
                        }
                        else {
                            sidebarShow.open();
                            sidebarShow.setToggleIsHidden(false);
                        }
                    }
                }
            }
            dataGen.getData($scope, {}, '/workspace/logo').then(function () {
                $workspace.logoUrl = $scope.data.logo;
            });
        });
    }

    var currentWorkspaceAllowed = function ($workspace, data) {
        var allowed = false;
        var i = 0;
        if (data.workspaces) {
            while (i < data.workspaces.length && !allowed) {
                if (!$workspaceIdHolder.currentWorkspaceId.value) {
                    $workspaceIdHolder.currentWorkspaceId.value = cookieService.getCookieValue(CONST_WORKSPACE_NAME + $context.userId.value);
                }
                if (data.workspaces[i].key === $workspaceIdHolder.currentWorkspaceId.value) {
                    allowed = true;
                }
                i++;
            }
        }
        return allowed;
    };

    function hasOtherWorkspaces() {
        return self.availableWorkspaces.workspaces.length > 1;
    }

    $rootScope.$on('$routeChangeSuccess', function (scope, next) {
        if (next.workspace && next.workspace !== $workspaceIdHolder.currentWorkspaceId.value) {
            self.activateWorkspace(next.workspace, false);
        }
    });

    self.getStartPage = function () {
        var availableWorkspaces = self.availableWorkspaces.workspaces;
        if (availableWorkspaces) {
            // get the first workspace that is available, order is the same as in the popup (defined in workspaceconfig.xml)
            // the default "view" of the workspace is the start page
            return availableWorkspaces[0].view;
        }
        return "lobby";
    };

    self.getCurrentWorkspaceId = function () {
        return $workspaceIdHolder.currentWorkspaceId;
    };

    self.getWorkspaces = function () {
        return impactX.isDefined(self, 'availableWorkspaces.workspaces');
    };

    self.refreshMenuItems = function (newWorkspaceIdentifier) {
        var tmpScope = {};
        dataGen.getData(tmpScope, {key: newWorkspaceIdentifier}, "/workspace/menu").then(function () {
            var data = tmpScope.data;
            if (data && typeof data === 'object' && data.workspace && typeof data.workspace === 'object') {
                    
                validateMenuItemsInWorkspace(data.workspace);

                if(ixUpgrade && ixUpgrade.extendWorkspaceMenuItems) {
                    ixUpgrade.extendWorkspaceMenuItems(data.workspace);
                }
                
                self.currentWorkspace = data.workspace;
                sendEventToListeners({
                    type: 'workspace.change',
                    data: data.workspace
                });
            }
        });
    };

    function containsView(view) {
        var menuItems = getCurrentWorkspace().menuitems;
        for (var i = 0; i < menuItems.length; i++)
        {
            var menuItem = menuItems[i];
            if (menuItem.view === view) {
                return true;
            }
            if (Array.isArray(menuItem.subitems)) {
                for (var j = 0; j < menuItem.subitems.length; j++)
                {
                    var subItem = menuItem.subitems[j];
                    if (subItem.view === view) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    //New for Angular
    function addListenerFn(listenerFn) {
        if(typeof listenerFn === 'function') {
            self._listenerFunctions.push(listenerFn);
            return true;
        }
        return false;
    }

    //New for Angular
    function removeListenerFn(listenerFn) {
        var idx;
        for(idx=0; idx < self._listenerFunctions.length; idx++) {
            if(self._listenerFunctions[idx]===listenerFn) {
                self._listenerFunctions.splice(idx,1);
                removeListenerFn(listenerFn);
                return;
            }
        }
    }

    //New for Angular
    function sendEventToListeners(eventData) {
        var idx;
        for(idx=0; idx < self._listenerFunctions.length; idx++) {
            self._listenerFunctions[idx](eventData);
        }
    }

    //New for Angular
    function validateMenuItemsInWorkspace(workspace) {
        var idx, item, newItems = [];
        // Check if there are some Angular-Components if it's an AngularJS-Only-App
        if(Array.isArray(workspace.menuitems) && !ixUseAngularComponents) {
            for(idx=0; idx < workspace.menuitems.length; idx++) {
                item = workspace.menuitems[idx];
                if(ixAngularOnlyMenuItems.indexOf(item.view) < 0) {
                    newItems.push(item);
                }
            }
            workspace.menuitems = newItems;
        }
    }

    function getHighContrastKey() {
        return self.highContrastKey;
    }

    function getHighContrastActive() {
        return self.highContrastActive;
    }

    function setHighContrastActive(val) {
        self.highContrastActive = val;
        sendEventToListeners({
            type: 'highcontrast.change',
            data: self.highContrastActive
        });
    }

    return {
        getCurrentWorkspace: getCurrentWorkspace,
        getCurrentWorkspaceView: getCurrentWorkspaceView,
        activateWorkspace: self.activateWorkspace,
        hasOtherWorkspaces: hasOtherWorkspaces,
        refreshAvailableWorkspaces: refreshAvailableWorkspaces,
        removeWorkspaceCookie: self.removeWorkspaceCookie,
        getCurrentWorkspaceId: self.getCurrentWorkspaceId,
        getWorkspaces: self.getWorkspaces,
        logoUrl: self.logoUrl,
        getStartPage: self.getStartPage,
        containsView: containsView,
        addListenerFn:addListenerFn,
        removeListenerFn:removeListenerFn,
        getHighContrastKey:getHighContrastKey,
        getHighContrastActive:getHighContrastActive,
        setHighContrastActive:setHighContrastActive
    };
}